// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 762 ? "44530001" : chunkId) + "-" + {"98":"d81b238d200c781b","762":"1450089d9e06a848"}[chunkId] + ".js";
};